import { render, staticRenderFns } from "./TripList.vue?vue&type=template&id=2b6b8ec3&scoped=true"
import script from "./TripList.vue?vue&type=script&lang=js"
export * from "./TripList.vue?vue&type=script&lang=js"
import style0 from "./TripList.vue?vue&type=style&index=0&id=2b6b8ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b8ec3",
  null
  
)

export default component.exports